import React from "react";
import { Row } from "antd";
import useProcuringEntityPackage from "../../../hooks/useProcuringEntityPackage";
import ActionBar from "../../components/ActionBar";
import Loader from "../../Packages/componets/Loader";

const OnGoingPackageOverview = ({ match }) => {
  const {
    params: { packageId },
  } = match;
  const { loading } = useProcuringEntityPackage(packageId);
  if (loading) {
    return <Loader flexDirection="column" fontSize={54} />;
  }

  return (
    <div style={{ padding: "24px", backgroundColor: "#f0f2f5" }}>
      {/* Page Heading */}
      <Row gutter={16} align="middle" style={{ width: "100%" }}>
        <ActionBar
          actionButtonProp={{
            title: `Ongoing Packages Overview`,
          }}
        />
       
      </Row>

    </div>
  );
};

export default OnGoingPackageOverview;
